import { Alert, Box, LinearProgress, Card, CardContent, CardMedia, CardActions, IconButton, Typography, Paper, Container, Grid, Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import usePostData from "../../../utility/usePostData";

const BackGroundImage = () => {
  const { isLoading, error, submitData } = usePostData();
  const [image, setImage] = useState("");
  const [title, setTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { data, isLoading: loading, paginate, refreshSearch } = useFetchDataWithPagination("slides");
  const [imagesListe, setImagesList] = useState(null);

  useEffect(() => {
    if (data?.data) {
      setImagesList(data.data.data);
    }
  }, [data]);

  const deleteImage = (id) => {
    const r = window.confirm("Êtes-vous sûr de vouloir supprimer cette image ?");
    if (r) {
      submitData(`slides/${id}`, null, "DELETE");
      refreshSearch();
    }
  };

  const saveData = (e) => {
    e.preventDefault();
    if (image === "" || title === "") {
      setErrorMessage("Veuillez remplir tous les champs");
      return;
    }
    const formData = new FormData();
    formData.append("image", image);
    formData.append("title", title);
    submitData("/slides", formData);
    refreshSearch();
    setImage("");
    setTitle("");
    setErrorMessage("");
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {isLoading && <LinearProgress color="success" sx={{ mb: 2 }} />}
      
      <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
        <Typography variant="h5" sx={{ mb: 3, color: "#00a652", fontWeight: 600 }}>
          Ajouter une nouvelle publicité
        </Typography>
        
        {(errorMessage || error) && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage || error?.message}
          </Alert>
        )}

        <form onSubmit={saveData}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                required
                label="Titre"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                size="small"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                sx={{ height: 40 }}
              >
                {image ? image.name : "Choisir une image"}
                <input
                  type="file"
                  hidden
                  accept=".jpeg,.jpg,.png"
                  onChange={(e) => setImage(e.target.files[0])}
                />
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{ 
                  backgroundColor: "#00a652", 
                  '&:hover': { backgroundColor: "#008a44" },
                  height: 40
                }}
              >
                Télécharger
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Box>
        {loading && <LinearProgress color="error" sx={{ mb: 2 }} />}
        
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
          Publicités actuelles
        </Typography>

        <Grid container spacing={3}>
          {imagesListe && imagesListe.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                transition: 'transform 0.2s',
                '&:hover': { transform: 'translateY(-4px)', boxShadow: 4 }
              }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={item.image}
                  alt={item.title}
                  sx={{ objectFit: 'cover' }}
                />
                <CardContent sx={{ flexGrow: 1, pb: 1 }}>
                  <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 500 }}>
                    {item.title}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    fullWidth
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => deleteImage(item.id)}
                    startIcon={<i className="fa fa-trash" />}
                  >
                    Supprimer
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
          {paginate()}
        </Box>
      </Box>
    </Container>
  );
};

export default BackGroundImage;